<template>
    <card>
        <div v-if="activeProfile !== null">
          <div class="row">
            <div class="col-8"><h2 :key="tick+'wacp'" v-on:click="() => {minimized = !minimized;tick++;}" class="inline">Hi {{ activeProfile.name }} <i :class="(minimized) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i></h2></div>
            <div class="col-4 text-right"><base-button icon="fas fa-sync-alt" type="primary" @click="setNoActiveProfile" >{{!smallScreen ? 'Profil ändern' : ''}}</base-button></div>
          </div>
          <div class="mb-2" v-if="!minimized"><profile-document-button></profile-document-button></div>
        </div>
        <div v-else>
            <h1 class="display-2">Profil wählen</h1>
            <p class="mt-0 mb-5">Aktuell ist kein Profil ausgewählt. Bitte Profil wählen:</p>
        </div>
        <ChangeProfile/>
    </card>
</template>
<script>
    import ChangeProfile from "@/views/Profiles/ChangeProfile";
    import ProfileDocumentButton from "@/views/ServiceDashboard/ProfileDocumentButton.vue";

    export default {
        name: 'ProfileArea',
        data() {
          return {
              minimized: true,
              tick: 1,
              smallScreen: false
          }
        },
        components: {ProfileDocumentButton, ChangeProfile},
        computed: {
            activeProfile() {
                return this.$store.getters['profiles/showActiveProfile'];
            }
        },
        created() {
            if (this.$store.getters['profiles/showActiveProfile'] === null && !this.$store.getters['profiles/isLoading']) this.$store.dispatch('profiles/getProfiles');
            this.smallScreen = window.innerWidth <= 768;
            },
        methods: {
            setNoActiveProfile() {
                this.$store.dispatch('profiles/setNoActiveProfile');
                this.tick++;
            }
        }
    }
</script>